export default __webpack_public_path__ + "images/emptyIcon.svg";